/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CatEventResponseDto } from './CatEventResponseDto';
import {
    CatEventResponseDtoFromJSON,
    CatEventResponseDtoFromJSONTyped,
    CatEventResponseDtoToJSON,
    CatEventResponseDtoToJSONTyped,
} from './CatEventResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface CatEventPaginationResponseDto
 */
export interface CatEventPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof CatEventPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<CatEventResponseDto>}
     * @memberof CatEventPaginationResponseDto
     */
    items: Array<CatEventResponseDto>;
}

/**
 * Check if a given object implements the CatEventPaginationResponseDto interface.
 */
export function instanceOfCatEventPaginationResponseDto(value: object): value is CatEventPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function CatEventPaginationResponseDtoFromJSON(json: any): CatEventPaginationResponseDto {
    return CatEventPaginationResponseDtoFromJSONTyped(json, false);
}

export function CatEventPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatEventPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(CatEventResponseDtoFromJSON)),
    };
}

export function CatEventPaginationResponseDtoToJSON(json: any): CatEventPaginationResponseDto {
    return CatEventPaginationResponseDtoToJSONTyped(json, false);
}

export function CatEventPaginationResponseDtoToJSONTyped(value?: CatEventPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(CatEventResponseDtoToJSON)),
    };
}

